import { useContext, useEffect, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import { AppLabel, AppSpan, AppText, CustomContainer, FlexRow } from "src/style"
import { BorrowingDetails } from "src/component"
import { moneyFormat } from "src/utils/utility"

export const BorrowingActivities: React.FC = () => {
    const {API} = useContext(ApiContext)
    const [isDetails, setIsDetails] = useState(false)
    const [selectedLoan, setSelectedLoan] = useState<any>(null)
    const [loans, setLoans] = useState<any>(null)
    const [range, setRange] = useState({min: 0, max: 0})

    useEffect(() => {
        handleFetchLoans()
    }, [])

    async function handleFetchLoans () {
        const response = await API.getBorrowingActivities()
        if (response) {
            //setRange({min: response.minimumAmountLent, max: response.maximumAmountLent})
            const info = {...response[0]}
            info.loanRepaymentResults = [
                {
                    "id": 0,
                    "initiated": true,
                    "paymentDate": "2023-04-14T19:10:04.332Z",
                    "beginningBalance": 0,
                    "scheduledPayment": 0,
                    "principalPayment": 0,
                    "interestPayment": 0,
                    "endingBalance": 0,
                    "amountPaid": 0,
                    "loanRequestId": 0,
                    "paid": true,
                    "charged": true,
                    "borrowersPhoneNumber": "string",
                    "lendersPhoneNumnber": "string",
                    "borrowerCustomerId": "string",
                    "lenderCustomerId": "string",
                    "userType": "string",
                    "paymentMadeDate": "2023-04-14T19:10:04.332Z",
                    "loanRequestReference": "string"
                }
              ]
            setLoans(response)
        }
    }

    function handleDetails (item: number) {
        setIsDetails(true)
        setSelectedLoan(item)
    }
    
    return (
        <>
            { !isDetails &&
                <CustomContainer>
                    <AppText textSize="1.8" fontWeight="700" color="#27272E" topMargin="3">Borrowing Activities</AppText>
                    <CustomContainer 
                        width="33" minHeight="9.9" borderColor="#E2E8F0"
                        radius="0.4" padding="1.5" topMargin="2.5"
                    >
                        <AppLabel textSize="1.2" fontWeight="600">Credit Limit</AppLabel>
                        <FlexRow>
                            <CustomContainer width="auto" sizeUnit="" rightMargin="1">
                                {/* <AppLabel textSize="1" color="#718096">Minimum amount lent</AppLabel> */}
                                <AppText textSize="1.6" fontWeight="500" color="#F16063">Min - ₦{moneyFormat(1000)}</AppText>
                            </CustomContainer>
                            <AppSpan color="##000000" textSize="1.7">|</AppSpan>
                            <CustomContainer width="auto" sizeUnit="" leftMargin="1">
                                {/* <AppLabel textSize="1" color="#718096">Maximum amount lent</AppLabel> */}
                                <AppText textSize="1.6" fontWeight="500" color="#4AAE8C">Max - ₦{moneyFormat(1000000)}</AppText>
                            </CustomContainer>
                        </FlexRow>
                    </CustomContainer>
                    <CustomContainer className="customer-info-view-nav-wrap" topMargin="2.5">
                        <CustomContainer 
                            overflow="auto"
                            style={{display: 'inline-block'}}
                        >
                            {
                                loans?.map((item: any, index: number) => {
                                    return (
                                        <FlexRow 
                                            gap="3" minWidth="90.3" wrap="wrap" bgColor={index % 2 != 0 ? '#F7FAFC' : '#ffffff'}
                                            padding="2" topPadding="1.5" bottomPadding="1.5" 
                                            radius="0.4" bottomMargin="1.7" key={index}
                                            borderColor={selectedLoan === index ? "#7895FF" : "#CBD5E0"}
                                            shadow={selectedLoan === index ? "0px 4px 20px rgba(0, 0, 0, 0.05)" : "none"}
                                            onClick={() => handleDetails(item)}
                                        >
                                            <CustomContainer width="11.5">
                                                <AppLabel textSize="1.2" color="#718096">Loan Type</AppLabel>
                                                <AppText textSize="1.2" color="#101225">{item.loanRequest?.loanOffer?.loanTypeName}</AppText>
                                            </CustomContainer>
                                            <CustomContainer width="11.5">
                                                <AppLabel textSize="1.2" color="#718096">Loan Amount</AppLabel>
                                                <AppText textSize="1.2" color="#101225">₦{moneyFormat(item.loanRequest?.loanOffer?.amountPerPerson)}</AppText>
                                            </CustomContainer>
                                            <CustomContainer width="11.5">
                                                <AppLabel textSize="1.2" color="#718096">Tenor</AppLabel>
                                                <AppText textSize="1.2" color="#101225">{item.loanRequest?.loanOffer?.tenor} {item.loanRequest?.loanOffer?.tenorType}(s)</AppText>
                                            </CustomContainer>
                                            <CustomContainer width="11.5">
                                                <AppLabel textSize="1.2" color="#718096">Interest rate</AppLabel>
                                                <AppText textSize="1.2" color="#101225">{item.loanRequest?.loanOffer?.interest}(%)</AppText>
                                            </CustomContainer>
                                            <CustomContainer width="11.5">
                                                <AppLabel textSize="1.2" color="#718096">Repayment</AppLabel>
                                                <AppText textSize="1.2" color="#101225">{item.loanRequest?.loanOffer?.rateName === 'FLAT' ? 'One-Off' : 'Installment'}</AppText>
                                            </CustomContainer>
                                            <CustomContainer width="11.5">
                                                <AppLabel textSize="1.2" color="#718096">Frequency</AppLabel>
                                                <AppText textSize="1.2" color="#101225">{item.loanRequest?.loanOffer?.repaymentTermName} repayment</AppText>
                                            </CustomContainer>
                                            <CustomContainer width="11.5">
                                                <AppLabel textSize="1.2" color="#718096">Negotiation</AppLabel>
                                                <AppText textSize="1.2" color="#101225">{item.loanRequest?.loanOffer?.isNegotiable ? 'Yes' : 'No'}</AppText>
                                            </CustomContainer>
                                            <CustomContainer width="11.5">
                                                <AppLabel textSize="1.2" color="#718096">Extension</AppLabel>
                                                <AppText textSize="1.2" color="#101225">{item.loanRequest?.loanOffer?.isExtensionAllowed ? 'Yes': 'No'}</AppText>
                                            </CustomContainer>
                                            <CustomContainer width="11.5">
                                                <AppLabel textSize="1.2" color="#718096">Extension time</AppLabel>
                                                <AppText textSize="1.2" color="#101225">{item.loanRequest?.loanOffer?.canBeExtendedBy} days</AppText>
                                            </CustomContainer>
                                            <CustomContainer width="11.5">
                                                <AppLabel textSize="1.2" color="#718096">Repayment date</AppLabel>
                                                <AppText textSize="1.2" color="#101225">-</AppText>
                                            </CustomContainer>
                                            <CustomContainer width="11.5">
                                                <AppLabel textSize="1.2" color="#718096">Payment</AppLabel>
                                                <AppText textSize="1.2" color="#101225">-</AppText>
                                            </CustomContainer>
                                            <CustomContainer width="11.5">
                                                <AppLabel textSize="1.2" color="#718096">Loan Status</AppLabel>
                                                <AppText textSize="1.2" color="#4AAE8C">{item.loanRequest?.completed ? 'Ended' : item.loanRequest?.confirmed ? 'Running' : 'Open'}</AppText>
                                            </CustomContainer>
                                        </FlexRow>
                                    )
                                })
                            }
                        </CustomContainer>
                    </CustomContainer>
                </CustomContainer>
            }
            { isDetails &&
                <BorrowingDetails
                    back={() => setIsDetails(false)}
                    data={selectedLoan}
                />
            }
        </>
    )
}